/** @format */

import React, { Component } from 'react'
import {
  message,
  Button,
  Input,
  Table,
  Select,
  Modal,
} from 'antd'
import {
  inspiration_getHotWord,
  inspiration_hotWordSave,
  hotWordAutoData,
} from '../../../api/inspiration'
import './index.css'
const { Option } = Select
const typeMap = [{}, { title: '图片热词' }, { title: '案例热词' }]

class Index extends Component {
  constructor(props) {
    super(props)
    let columns = [
      {
        title: '序值',
        dataIndex: 'sort',
        key: 'sort',
        width: '60px',
      },
      {
        title: '排名',
        dataIndex: 'index',
        key: 'index',
        width: '60px',
      },
      {
        title: '热词名称',
        dataIndex: 'word',
        key: 'word',
        width: '60px',
      },
      {
        title: '热词属性',
        dataIndex: 'type',
        key: 'type',
        width: '60px',
        render: (text) => typeMap[text]?.title,
      },
      {
        title: '维护时间',
        dataIndex: 'gmtModified',
        key: 'gmtModified',
        width: '120px',
      },
      {
        title: '状态',
        dataIndex: 'isDeleted',
        key: 'isDeleted',
        width: '60px',
        render: (status) => {
          if (status === 0) {
            return '启用中'
          } else if (status === 1) {
            return '停用中'
          }
        },
      },
      {
        title: '操作',
        dataIndex: 'opt',
        key: 'opt',
        width: '200px',
        render: (opt, record) => {
          return (
            <div className='operation-recommend-btn'>
              <Button onClick={this.changeStatus.bind(this, record)}>
                {record.isDeleted === 1 ? '启用' : '停用'}
              </Button>
              <Button onClick={this.editWords.bind(this, record)}>编辑</Button>
              <Button onClick={this.onlyLook.bind(this, record)}>查看</Button>
            </div>
          )
        },
      },
    ]
    this.state = {
      pageSize: 10,
      type: '',
      word: '',
      status: '',
      name: '',
      tableData: [],
      columns,
      loading: false,
      visible: false,
      radioValue: [true, false, false],
      autoData: '',
      madalHotWords: '',
      madalHotStatus: 0,
      madalInputValue: '',
      madalsort: '', // 序值
      madalUrl: '', // url
      modalType: 1, // 属性
      isOnlyLook: false,
      isEdit: false,
      totalCount: 0,
      hotwordType: 0,
      pagination: {
        total: 0,
        current: 1,
      },
      isEditId: '',
    }
  }

  componentDidMount() {
    this.getHotWordData()
  }

  getHotWordData = (param) => {
    let { pageSize } = param || {}
    let params = {
      page: pageSize || this.state.pagination.current,
      size: this.state.pageSize,
      word: this.state.word,
      isDeleted: this.state.status,
    }

    if (this.state.hotwordType) {
      params.type = this.state.hotwordType
    }
    if (pageSize) {
      let newPage = {
        ...this.state.pagination,
        current: pageSize,
      }
      this.setState({ pagination: newPage })
    }
    this.setState({ loading: true })
    inspiration_getHotWord(params)
      .then((res) => {
        if (res && res.error && res.error.code === 0) {
          let data = res.data.content || []
          if (data.length) {
            data = data.map((item, index) => {
              return {
                ...item,
                index: index + 1 + 10 * (this.state.pagination.current - 1),
              }
            })
          }
          let page = {
            ...this.state.pagination,
            total: res.data.totalElements ? Number(res.data.totalElements) : 0,
          }
          this.setState({ tableData: data, loading: false, pagination: page })
        }
      })
      .catch((e) => {
        message.error(e)
      })
  }

  onlyLook = (record) => {
    let data = [true, false, false]
    if (record.resultCount > 0) {
      data = [false, false, true]
    }
    this.setState({
      visible: true,
      madalHotStatus: record.type,
      madalsort: record.sort,
      modalType: record.type,
      madalHotWords: record.word,
      radioValue: data,
      autoData: '',
      madalInputValue: record.resultCount > 0 ? record.resultCount : '',
      isOnlyLook: true,
      isEdit: false,
    })
  }

  editWords = (record) => {
    let data = [true, false, false]
    if (record.resultCount > 0) {
      data = [false, false, true]
    }
    this.setState({
      visible: true,
      madalHotStatus: record.type,
      madalsort: record.sort,
      modalType: record.type,
      madalHotWords: record.word,
      radioValue: data,
      autoData: '',
      madalInputValue: record.resultCount > 0 ? record.resultCount : '',
      isEditId: record.id,
      isEdit: true,
    })
  }

  handleChange = (value) => {
    this.setState({ type: value })
  }

  changeStatus = (record) => {
    let params = {
      id: record.id,
      word: record.word,
      sort: record.sort,
      isDeleted: record.isDeleted === 0 ? 1 : 0,
    }
    inspiration_hotWordSave(params)
      .then((res) => {
        if (res && res.error && res.error.code === 0) {
          this.getHotWordData()
        }
      })
      .catch((e) => {
        message.error(e)
      })
  }

  handleChangeStatus = (value) => {
    this.setState({ status: value })
  }

  queryData = () => {
    this.getHotWordData({ pageSize: 1 })
  }

  handleInputChange = (e) => {
    this.setState({ word: e.target.value })
  }

  addNewWords = () => {
    this.setState({ visible: true, isEdit: false, })
  }

  handleOk = () => {
    if (this.state.isOnlyLook) {
      this.resetData()
      return
    }
    if (!this.state.madalHotWords || !this.state.madalsort) {
      message.error('序值、热词名称都不可输入为空')
      return
    }
    let resultCount = 0
    if (this.state.autoData) {
      resultCount = this.state.autoData
    } else if (this.state.madalInputValue) {
      resultCount = this.state.madalInputValue
    }
    let params = {
      word: this.state.madalHotWords,
      sort: this.state.madalsort,
      type: this.state.modalType,
      isDeleted: 0,
    }
    if (this.state.isEditId) {
      params = {
        id: this.state.isEditId,
        ...params,
      }
    }
    inspiration_hotWordSave(params)
      .then((res) => {
        if (res && res.error && res.error.code === 0) {
          this.getHotWordData({ pageSize: 1 })
          this.resetData()
        } else {
          message.error(res.data)
        }
      })
      .catch((e) => {
        message.error(e)
      })
  }

  handleCancel = () => {
    this.resetData()
  }

  resetData = () => {
    this.setState({
      visible: false,
      radioValue: [true, false, false],
      autoData: '',
      madalHotWords: '',
      madalHotStatus: 0,
      madalInputValue: '',
      madalsort: '', // 序值
      moddalType: 1,
      isOnlyLook: false,
      isEditId: '',
    })
  }

  changeRadioStatus = (index) => {
    if (!this.state.madalHotWords) {
      message.error('热词不能为空')
      return
    }
    let data = this.state.radioValue
    data = data.map((item) => {
      return false
    })
    data[index] = true
    if (index === 1) {
      this.getHotWordAutoData()
    } else {
      this.setState({ autoData: 0 })
    }
    this.setState({ radioValue: data, madalInputValue: '', autoData: '' })
  }

  getHotWordAutoData = () => {
    let params = {
      word: this.state.madalHotWords,
      type: this.state.madalHotStatus,
    }
    hotWordAutoData(params)
      .then((res) => {
        if (res && res.error && res.error.errorCode === 0) {
          this.setState({ autoData: res.data })
        } else {
          message.error(res.data)
        }
      })
      .catch((e) => {
        message.error(e)
      })
  }

  changeHotWords = (e) => {
    this.setState({ madalHotWords: e.target.value })
  }

  changeModalType = (e) => {
    this.setState({ modalType: e })
  }

  changeSort = (e) => {
    this.setState({ madalsort: e.target.value })
  }

  changeHotWordsUrl = (e) => {
    this.setState({ madalUrl: e.target.value })
  }

  handleChangeModal = (value) => {
    this.setState({ madalHotStatus: value })
  }

  handleChangeHotWordType = (value) => {
    this.setState(
      {
        hotwordType: value,
      },
      () => {
        console.log(this.state.hotwordType)
      }
    )
  }

  manualValue = (e) => {
    this.setState({ madalInputValue: e.target.value })
  }

  changePage = (page) => {
    let newPage = {
      ...this.state.pagination,
      current: page.current,
    }
    this.setState({ pagination: newPage })
    this.getHotWordData({ pageSize: page.current })
  }

  render() {
    let { tableData, loading } = this.state
    return (
      <div>
        <div className='top-recommend-optArea'>
          <div className='top-recommend-searchArea'>
            热词名称：
            <Input
              style={{ width: 140 }}
              placeholder='请输入热词名称'
              onChange={this.handleInputChange}
            />
          </div>
          <div className='top-recommend-statusArea'>
            状态：
            <Select
              defaultValue=''
              style={{ width: 120 }}
              onChange={this.handleChangeStatus}
            >
              <Option value=''>全部</Option>
              <Option value='0'>启用中</Option>
              <Option value='1'>停用中</Option>
            </Select>
          </div>
          <div className='top-recommend-statusArea'>
            属性：
            <Select
              value={this.state.hotwordType}
              style={{ width: 120 }}
              onChange={this.handleChangeHotWordType}
            >
              <Option value={0}>全部</Option>
              <Option value={1}>图片热词</Option>
              <Option value={2}>案例热词</Option>
            </Select>
          </div>
          <div className='top-recommend-btnArea'>
            <div className='top-recommend-executeBtn'>
              <Button type='primary' onClick={this.queryData}>
                查询
              </Button>
            </div>
            <div className='top-recommend-addBtn'>
              <Button onClick={this.addNewWords}>新增</Button>
            </div>
          </div>
        </div>
        <Table
          loading={loading}
          pagination={this.state.pagination}
          onChange={this.changePage}
          columns={this.state.columns}
          dataSource={tableData}
          rowKey={(record) => record.id}
        />
        <Modal
          title='添加搜索排名热词'
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText={this.state.isOnlyLook ? '关闭' : '保存'}
          cancelText='取消'
          destroyOnClose={true}
        >
          <div className='modal-recommend-typeArea'>
            属性：
            <Select
              style={{ width: 400 }}
              value={this.state.modalType}
              onChange={this.changeModalType}
              disabled={this.state.isOnlyLook || this.state.isEdit}
            >
              <Select.Option value={1}>图片热词</Select.Option>
              <Select.Option value={2}>案例热词</Select.Option>
            </Select>
          </div>
          <div className='modal-recommend-typeArea'>
            序值：
            <Input
              style={{ width: 400 }}
              placeholder='请输入序值'
              value={this.state.madalsort}
              onChange={this.changeSort}
              disabled={this.state.isOnlyLook}
            />
          </div>
          <div className='modal-recommend-typeArea'>
            热词：
            <Input
              style={{ width: 400 }}
              placeholder='请输入热词'
              value={this.state.madalHotWords}
              onChange={this.changeHotWords}
              disabled={this.state.isOnlyLook}
            />
          </div>
        </Modal>
      </div>
    )
  }
}

export default Index
